import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Image from 'common/image/Image';

const imgWidth = 200;
const imgHeight = 141;
const imgURL = `https://res.cloudinary.com/spothero/image/upload/c_fill,dpr_2.0,h_${imgHeight},w_${imgWidth},q_50,f_auto/`;

const HowToRedeem = ({sectionTitle, instructions}) => {
    return (
        <div className="SpotDetails-section HowToRedeem">
            <h4 className="subtitle">{sectionTitle}</h4>
            <ol>
                {instructions.map((instruction, i) => {
                    const classes = classNames(
                        {'no-illustration': !instruction.illustration_id},
                        {'no-number': instructions.length < 2}
                    );

                    return (
                        <li className={classes} key={i}>
                            <div className="RedemptionInstruction">
                                <div className="RedemptionInstructionRow">
                                    <div className="RedemptionInstructionIllustration">
                                        {instruction.illustration_id && (
                                            <Image
                                                width={imgWidth}
                                                height={imgHeight}
                                                src={`${imgURL}${instruction.illustration_id}`}
                                            />
                                        )}
                                    </div>
                                    <div className="RedemptionInstructionText">
                                        <span
                                            className="RedemptionInstructionText-content"
                                            dangerouslySetInnerHTML={{
                                                __html: instruction.text.replace(
                                                    '\n',
                                                    '<br>'
                                                ),
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </li>
                    );
                })}
            </ol>
        </div>
    );
};

HowToRedeem.propTypes = {
    sectionTitle: PropTypes.string.isRequired,
    instructions: PropTypes.arrayOf(
        PropTypes.shape({
            illustration_id: PropTypes.string, // eslint-disable-line camelcase
            illustration_version: PropTypes.string, // eslint-disable-line camelcase
            text: PropTypes.string,
            id: PropTypes.number,
            position: PropTypes.number,
        })
    ),
};

export default HowToRedeem;
